import { STATE_COLORS } from './statusColors';

// Mirrors backend Organisation.Status enum — values must match exactly.
export const ORG_STATUS = Object.freeze({
  PENDING: 'Pending',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
});

export const ORG_STATUS_COLORS = Object.freeze({
  [ORG_STATUS.ACTIVE]: STATE_COLORS.COMPLETE,
  [ORG_STATUS.PENDING]: STATE_COLORS.INPROGRESS,
  [ORG_STATUS.INACTIVE]: STATE_COLORS.DRAFT,
});
